import { env } from "../env";

export const API_BASE_URL = "https://exportpadi-api.apps.rokswood.com";
export const REQUEST_TIMEOUT = 10000;
export const API_CONFIG = {
  DEFAULT_HEADERS: {
    "Content-Type": "application/json",
  },
  MAX_RETRIES: 3,
  RETRY_DELAY_BASE: 1000,
};
export const PUBLIC_ENV = {
  seller: env.NEXT_PUBLIC_SELLER || "",
  buyer: env.NEXT_PUBLIC_BUYER || "",
  admin: env.NEXT_PUBLIC_ADMIN || "",
};

export const AUTH_TOKEN = "auth_token";
